<template lang="html">
    <div class="header-right">
        <div class="header-alert" v-show="alertFlag">

          <el-badge :value="alertValue"  v-if ="alertValue==0" hidden class="item" >
              <el-button icon="el-icon-bell" circle @click="handleAlert"></el-button>
          </el-badge>
            <el-badge :value="alertValue" v-else  class="item" >
               <el-button icon="el-icon-bell" circle @click="handleAlert"></el-button>
           </el-badge>
        </div>

        <div class="international">
            <img class="country-img" :src="countryImg">

            <el-select class="international-select" v-model="selectedCountry" @change="changeInternational" placeholder="">
              <el-option v-for="item in options" :key="item.value" :label="item.valueKey" :value="item.value">
                  <img class="option-img" :src="item.label"><span>&nbsp;&nbsp;{{item.valueKey}}</span>
              </el-option>
            </el-select>
        </div>


        <div class="header-main">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    <div class="user-btn">
                        <img class="header-icon" src="static/img/user_header.png">
                    </div>
                    <i class="el-icon-arrow-down el-icon--right header-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="user-dropdown">
                    <el-dropdown-item><div @click="showEditDialog"><img class="header-item-icon" src="static/img/edit_new.png">{{$t('message.modifyPassword')}}</div></el-dropdown-item>
                    <el-dropdown-item><div @click="submitQuit"><img class="header-item-icon" src="static/img/quit_new.png">{{$t('message.logoutTip')}}</div></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <el-dialog title="" :visible.sync="quitDialogVisible" width="30%" class="quit-dialog warn-dialog" :modal-append-to-body='false'>
            <div class="warn-container flex-row">
                <img class="warn-icon" alt="" src="static/img/alertWarn.png">
                <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
            </div>

            <div class="dialog-body">
                <span>{{$t('message.downloadCreate')}}Confirm logout？</span>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button class="verifone-btn" type="primary" plain @click="quitDialogVisible = false">Cancel</el-button>
                <el-button class="verifone-btn" type="primary" @click="submitQuit()">Yes</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {
            editDialogVisible: false,
            quitDialogVisible: false,
            currentPassword: '',
            newPassword: '',
            passwordAgain: '',
            selectedCountry: 0,
            alertValue: null,
            alertFlag: false,
            logout: this.$t('message.logout'),
            timer: null,
            countryImg: 'static/img/UK.png',
            options: [{
              value: 0,
              label: 'static/img/UK.png',
              valueKey: 'English'
            }, {
              value: 1,
              label: 'static/img/China.png',
              valueKey: '中文'
            }]
        };
    },
    mounted() {
		this.setLanguage();
        this.setAlertValue();
	},
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        setLanguage() {
            let languageDefault = sessionStorage.getItem('defaultLanguage');

            if(languageDefault == 'en') {
                this.selectedCountry = 0;
                this.countryImg = 'static/img/UK.png';
                this.$i18n.locale = 'en';
                sessionStorage.setItem('acceptLanguage', 'en-US, en');
            }else if(languageDefault == 'cn') {
                this.selectedCountry = 1;
                this.countryImg = 'static/img/China.png';
                this.$i18n.locale = 'cn';
                sessionStorage.setItem('acceptLanguage', 'zh-CN, zh');
            }
        },
        showEditDialog() {
            this.$router.replace('/modifyPassword');
        },
        handleAlert() {
            this.$router.replace('/openAlert');
        },
        setAlertValue() {
            let role = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str)),
                that = this;

            this.alertFlag = role.indexOf(70) == -1 && role.indexOf(71) == -1 ? false : true;

            if(this.alertFlag) {
                this.queryAlertNum();

                this.timer = setInterval(function() {
                    that.queryAlertNum();
                }, 120 * 1000);
            }

        },
        queryAlertNum() {
            this.$axios({
                method: 'post',
                url: "/marketplace/alert/count"
            }).then(response => {
                if (response.data.resultCode != 0) {
                    return;
                }else {
                    this.alertValue = response.data.count;
                    console.log("aaaaa:"+JSON.stringify(response.data.count))


                }
            }).catch((err) => {
                console.log(err);
            });
        },
        changeInternational(item) {
            let routerStr = window.location.href.split('#')[1];

            if(item == 0) {
                this.countryImg = 'static/img/UK.png';
                sessionStorage.setItem('defaultLanguage', 'en');
                sessionStorage.setItem('acceptLanguage', 'en-US, en');
                this.$i18n.locale = 'en';
            }else {
                this.countryImg = 'static/img/China.png';
                sessionStorage.setItem('defaultLanguage', 'cn');
                sessionStorage.setItem('acceptLanguage', 'zh-CN, zh');
                this.$i18n.locale = 'cn';
            }
            console.log(routerStr);
            // this.$router.replace(routerStr);
            // this.$router.reload();
            this.reload();
        },
        checkInput() {
            if(!this.currentPassword || !this.newPassword || !this.passwordAgain) {
                this.$message({
                    showClose: true,
                    message: 'Input can not be empty',
                    type: 'error'
                });
                return;
            }

            if(this.passwordAgain == this.newPassword) {
                this.submitModify();
            }else {
                this.$message({
                    showClose: true,
                    message: 'New and confirmed passwords are not the same!',
                    type: 'error'
                });
            }

        },
        submitModify() {
            this.$axios.post("/marketplace/user/password", {
                current: this.currentPassword,
                newPwd: this.passwordAgain
            }).then(response => {
                if (response.data.resultCode != 0) {
                    this.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'2000',
                    });
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: "Modified sucess!",
                        duration:'2000',
                    });

                    this.editDialogVisible = false;

                    setTimeout(function() {
                        this.submitQuit();
                    }, 2000);

                }
            }).catch((err) => {
                console.log(err);
            });
        },
        submitQuit() {
            let that = this;
            this.$axios.post("/marketplace/logout", {
            }).then(response => {
                if (response.data.resultCode != 0) {
                    that.$message({
                        type: "error",
                        message: response.data.desc,
                        duration:'2000',
                    });
                    return;
                }else {
                    this.$message({
                        type: "success",
                        message: this.logout,
                        duration:'2000',
                    });

                    this.quitDialogVisible = false;
                    sessionStorage.setItem('verifoneLoginFlag', false);

                    setTimeout(function() {
                        that.$router.replace('/login');
                    }, 1000);
                }
            }).catch((err) => {
                console.log(err);
            });
        }
    }
}
</script>

<style scope>
.header-container {
    z-index: 5;
}
.edit-item {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
}
.header-icon {
    width: 40px;
    height: 40px;
}
.header-alert {
    width: 50px;
    right: 450px;
    position: absolute;
    top: 15px;
}
/* .international-select .el-select-dropdown__item { */
.el-select-dropdown__item {
    display: flex;
    display: -webkit-display;
}
.international-select {
    width: 160px;
}
.international {
    position: absolute;
    right: 140px;
    top: 15px;
}
.header-main {
    position: absolute;
    right: 18px;
    top: 8px;
}
.header-item-icon {
    width: 25px;
    height: 25px;
    position: relative;
    top: 7px;
    margin-right: 10px;
}
.header-main {
    font-size: 28px;
    font-weight: 600;
}
.header-down {
    /* color: #fff; */
    position: absolute;
    right: 20px;
    top: -5px;
    font-size: 14px;
    font-weight: 900;
    color: #dcdfe6;
    cursor: pointer;
}
.edit-item {
    margin-top: 10px;
}
.edit-item>span {
    width: 210px;
    height: 40px;
    line-height: 40px;
}
.edit-main {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
}
.edit-main span {
    margin: 15px 0 8px 0;
}
.option-img {
    width: 40px;
    height: 40px;
}
.country-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 2px;
    left: -50px;
}
.header-icon {
    width: 20px;
    height: 20px;
}
.user-btn {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #dcdfe6;
    display: flex;
    display: -webkit-display;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 45px;
    top: -17px;
    cursor: pointer;
}
.user-dropdown {
    top: 55px!important;
}
.international .el-input__inner, .international .el-input__inner:hover, .international .el-input__inner:focus {
    border: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue